import React from "react";
import Lottie from 'react-lottie';
import animationData from '../../assets/loader/Loader.json';

const SpinnerTimeLoader = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <Lottie
            options={defaultOptions}
            height={118}
            width={118}
        />
    );
};

export default SpinnerTimeLoader;